import { createApiActionType } from 'app/store/utils';

const apiType = createApiActionType('tableDetails');

export const LOAD_TABLE_DETAILS = apiType('LoadTableDetails');
export const GET_PROJECT_REFERENCES_OF_TABLE = apiType('GetProjectReferencesOfTable');
export const GET_TABLE_DETAILS_FOR_DATA_BROWSER = apiType('GetTableDetailsForDataBrowser');
export const GET_DOWNSTREAM_REFERENCES = apiType('GetDownstreamReferences');
